<template>
  <footer class="footer">
    <v-container>
      <v-row>
        <!-- <v-col cols="12" sm="12" md="3" data-aos="fade-up">
          <div
            data-aos="fade-up"
            class="text-h6 text-light mb-4"
            v-text="'OUR COMPANY'"
          ></div>
          <div class="footer-links" data-aos="fade-up">
            <a :href="'https://routeline.com/pages/careers'" class="footer-link">
              career
            </a>
            <router-link
              :to="'/membership'"
              class="footer-link"
              v-if="!isMember"
            >
              membership
            </router-link>
            <a :href="'https://routeline.com/pages/about'" class="footer-link" v-if="!isMember">
              about us
            </a>
            <a :href="'https://routeline.com/pages/contact'" class="footer-link">
              contact us
            </a>
          </div>
        </v-col> -->
        <v-col cols="12" sm="12" md="9" data-aos="fade-up">
          <div id="Customer-service" data-aos="fade-up" class="text-h6 text-light mb-4" v-text="'CUSTOMER SERVICE'">
          </div>
          <div class="footer-links" data-aos="fade-up">
            <a :href="'https://routeline.com/policies/privacy-policy'" class="footer-link" id="privacy-policy">
              privacy policy
            </a>
            <a :href="'https://routeline.com/policies/terms-of-service'" class="footer-link" id="term-conditions">
              Terms & Conditions
            </a>
            <a :href="'https://routeline.helpscoutdocs.com/'" class="footer-link" id="frequently-question">
              Frequently asked questions
            </a>
            <router-link :to="'/membership'" class="footer-link" v-if="!isMember" id="register-membership">
              Register for Member
            </router-link>
            <a :href="'https://routeline.com/policies/refund-policy'" class="footer-link" id="refund-policy">
              refund policy
            </a>
          </div>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="4" data-aos="fade-up">
          <div class="mb-4">
            <div
              class="text-subtitle-1 text-light"
              v-text="'SIGN UP AND SAVE'"
            ></div>
            <div
              class="text-subtitle-2 text-light"
              v-text="'Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.'"
            ></div>
          </div>
          <v-text-field
            solo
            label="Enter your email"
            prepend-inner-icon="mdi-email"
            dark
          ></v-text-field>
        </v-col> -->
        <v-col cols="12" sm="12" md="3">
          <img src="@/assets/logo-white.png" id="footer-image" class="footer-image" alt="" />
          <div class="footer-links mt-3" data-aos="fade-up">
            <v-row>
              <v-col cols="3">
                <a href="https://business.facebook.com/RouteLineCo/" id="fb-link">
                  <v-icon dark> mdi-facebook </v-icon>
                </a>
              </v-col>
              <v-col cols="3">
                <a href="https://www.instagram.com/routelineco/" id="insta-link">
                  <v-icon dark> mdi-instagram </v-icon>
                </a>
              </v-col>
              <v-col cols="3">
                <a href="https://www.tiktok.com/@routelineco" id="tiktok-link">
                  <img src="@/assets/icons/tiktok.svg" style="width: 22px" alt="" />
                </a>
              </v-col>
              <v-col cols="3">
                <a href="https://www.youtube.com/channel/UCCoVUtIsuleNBtfCxnHvkWw" id="youtube-link">
                  <v-icon dark> mdi-youtube </v-icon>
                </a>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- <router-link class="ml-5 footer-help" tag="div" to="/support">
      <v-icon style="color: var(--light)">mdi-help-circle</v-icon>
      <span>Support</span>
    </router-link> -->
    <div class="footer-copy" id="footer-copy">© 2022 RouteLine.</div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    isMember() {
      return this.user?.member;
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  background-color: var(--primary-color);
  padding-bottom: 15px;
  padding-top: 25px;
  margin-top: -20px;

  &-copy {
    color: var(--light);
    font-size: 14px;
    text-align: center;
    margin-bottom: 10px;
    padding: 20px 0;
  }

  &-help {
    color: var(--light);
    font-weight: bold;
    cursor: pointer;
  }

  &-seprator {
    width: 100%;
    height: 3px;
    background: var(--light);
    margin-top: 20px;
    margin-bottom: 20px;
  }

  &-image {
    width: 220px;
  }

  &-link {
    color: var(--light);
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    text-decoration: none;
    display: block;
    margin: 8px 0;
    transition: all 0.3s ease;

    &:hover {
      color: var(--light);
      transform: translateX(7px);
    }
  }
}

@media screen and (max-width: 960px) {
  .footer {
    padding-bottom: 180px;
  }
}
</style>
